<template>
  <div>
    <div class="d-flex justify-content-between align-items-baseline w-100">
      <h5 class="font-weight-bold text-secondary">
        <u>
          <router-link :to="{
              path: '/shipment/' + item.id
            }"
          >Invoice#{{ item.shipmentId }}</router-link>
        </u>
      </h5>
      <h6 class="text-secondary">
        <b-dropdown
          id="dropdown-1"
          toggle-class="rounded-pill text-xs py-0 px-2 mr-1"
          menu-class="text-xs border-0 shadow-lg"
          variant="secondary"
        >
          <template v-slot:button-content>
            <b-icon-flag-fill
              :style="{ color: item.flag ? flagColor[item.flag] : '#eeeeee' }"
            ></b-icon-flag-fill>
          </template>
          <b-dropdown-item
            link-class="d-flex justify-content-between align-items-center px-3"
            @click.stop="$emit('change-flag', (item.flag === 'short' ? '' : 'short'))"
          >
            <div>
              <b-icon-flag-fill
                :style="{color: flagColor['short']}"
              ></b-icon-flag-fill>
              Short Shipped
            </div>
            <b-icon-check v-if="item.flag === 'short'"></b-icon-check>
          </b-dropdown-item>
          <b-dropdown-item
            link-class="d-flex justify-content-between align-items-center px-3"
            @click.stop="$emit('change-flag', (item.flag === 'delayed' ? '' : 'delayed'))"
          >
            <div>
              <b-icon-flag-fill
                :style="{color: flagColor['delayed']}"
              ></b-icon-flag-fill>
              Delayed
            </div>
            <b-icon-check v-if="item.flag === 'delayed'"></b-icon-check>
          </b-dropdown-item>
          <b-dropdown-item
            link-class="d-flex justify-content-between align-items-center px-3"
            @click.stop="$emit('change-flag', (item.flag === 'other' ? '' : 'other'))"
          >
            <div>
              <b-icon-flag-fill
                :style="{color: flagColor['other']}"
              ></b-icon-flag-fill>
              Other Error
            </div>
            <b-icon-check v-if="item.flag === 'other'"></b-icon-check>
          </b-dropdown-item>
        </b-dropdown>
        <b-badge pill style="background: #a779ae; color: white;">
          Warehouse Record
        </b-badge>
      </h6>
    </div>
    <h5 class="font-weight-bold text-left text-muted text-sm">
      <u>
        <router-link :to="{
            path: '/manifest-proto/' + item.booking
        }">
          MAN#{{ item.bookingId ? item.bookingId : 'NOT-ASSIGNED' }}
        </router-link>
      </u>
    </h5>
    <h6 class="text-secondary text-left">
      {{ item.shipperName }}
      <b-icon-dot></b-icon-dot>
      {{ item.shipperCity }}
      <b-icon-arrow-right></b-icon-arrow-right>
      {{ item.consigneeCity }}
      <b-icon-dot></b-icon-dot>
      Date Created {{ new Date(item.dateCreated).toLocaleDateString('en-US', {timeZone: 'UTC'})}}
    </h6>
    <div class="text-left mb-0 pb-3 font-weight-bold" style="font-size: 14px; color: gray;">
      Outstanding Balance ${{ item.outStandingBalance }}
    </div>
     <b-collapse
      :id="'result-card' + item.id"
      class="text-left text-xs text-gray-900"
    >
      <h6 class="text-muted mt-4 font-weight-bold" style="font-size: smaller;">
        ADDITIONAL DETAILS
      </h6>
      <div class="mb-3 mx-3">
        <b-row class="border rounded pt-2">
          <b-row class="w-100 m-0">
            <b-col md="4" lg="3" xl="2" class="pb-2">
              <label class="text-gray-400 font-weight-bold mb-0">Pieces</label>
              <div>
                <span class="text-xl text-gray-800">{{ completedCount }}</span>
                <span class="text-xs text-gray-500">/{{ item.items.length }}</span>
              </div>
            </b-col>
            <b-col md="8" lg="9" xl="10" class="pb-2 d-none d-md-block">
              <label class="text-gray-400 font-weight-bold mb-2">Progress</label>
              <b-progress
                v-if="completedPercentage < 100"
                :max="100"
                class="w-100"
                style="border-radius: 30px;"
              >
                <b-progress-bar :value="completedPercentage" variant="warning" striped>
                  <span>{{ completedPercentage }}%</span>
                </b-progress-bar>
              </b-progress>
              <b-button
                v-else
                block
                class="text-xs py-0"
                variant="success"
                style="border-radius: 30px;"
                @click="()=>{}"
              >Complete</b-button>
            </b-col>
          </b-row>

          <b-row v-for="(piece, idx) in item.items" :key="idx" class="w-100 mx-0">
            <hr class="w-100 my-0" />
            <b-col offset-md="4" offset-lg="3" offset-xl="2" class="my-2">
              <b-form-checkbox
                :id="`checkbox${piece.id}`"
                class="d-flex align-items-center"
                v-model="piece.completed"
                :name="`checkbox${idx}`"
              >
                {{ piece.description }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-row>
      </div>
      <b-button
          class="text-xs py-0 px-2 mr-1"
          variant="success"
          style="border-radius: 30px; "
          @click="updateItems()"
        >
          update
      </b-button>
    </b-collapse>
  </div>
</template>

<script>

import { updateLoadItem } from '../api/shipment';

export default {
  name: 'SearchResultWarehouse',
  data() {
    return {
      flagColor: {
        short: '#e26565',
        delayed: '#d476fd',
        other: '#8abdd0',
      },
    };
  },
  methods: {
    updateItems() {
      const complete = this.completedPercentage === 100;
      const data = {
        data:
          {
            items: this.item.items, completed: complete, shipmentId: this.item.id,
          },
      };
      updateLoadItem(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.$emit('update-item');
        }).catch((err) => {
          this.$emit('error-item', err.response.data.error);
        });
    },
  },
  computed: {
    completedCount() {
      return this.item.items.reduce((acc, curr) => (curr.completed ? acc + 1 : acc), 0);
    },
    completedPercentage() {
      return +((this.completedCount / this.item.items.length) * 100).toFixed(2);
    },
  },
  props: ['item', 'name', 'phoneNumber', 'destination', 'bol', 'accountNumber'],
};
</script>

<style scoped>

</style>
